import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';

import { Mensaje, MensajeSiNo } from '../../../mensajes2';
import { Dimmer } from '../../../spinner';
import useTable from '../../../useTable';
import { Toasts } from '../../../toasts';

import { Input } from '../../../../ui/inputs/Input';
import { PrimaryButton } from '../../../../ui/buttons/Button';
import Bancos from './Bancos'; // Importar el componente modal

const TablaBancos = (props) => {
    var op = require('../../../../modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const [mostrar, setMostrar] = useState(false);
    const [id, setId] = useState(0);
    const [operacionModal, setOperacionModal] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [idModal, setIdModal] = useState('');

    // Definir los headCells para bancos
    const headCells = [
        { id: 'codban', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
        { id: 'nomban', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRE DEL BANCO', textAlign: 'center' },
        { id: 'sucursal', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'SUCURSAL', textAlign: 'center' },
        { id: 'nrocue', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NRO CUENTA', textAlign: 'center' },
        { id: 'gerente', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'GERENTE', textAlign: 'center' },
        { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'OPCIONES', textAlign: 'center' }
    ]

    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtBuscador = useRef();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const permiso = JSON.parse(localStorage.getItem('accbanco'))
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                const query = target.value.toLowerCase();
                if (query === "") return items;

                return items.filter(x =>
                    (x.codban?.toString().toLowerCase().includes(query)) ||
                    (x.nomban?.toLowerCase().includes(query)) ||
                    (x.sucursal?.toLowerCase().includes(query)) ||
                    (x.nrocue?.toString().toLowerCase().includes(query)) ||
                    (x.gerente?.toLowerCase().includes(query))
                );
            }
        });
    };

    const seleccionarRegistros = () => {
        let codigoNomina = localStorage.getItem('codigonomina');
        codigoNomina = codigoNomina.replace(/"/g, '');

        let campos = "*";
        let nomtab = `nomi${codigoNomina}.banco`;
        let condi = props.condicion ? props.condicion : " 1=1 ";
        let orden = "codban";
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    console.log('Bancos cargados:', response.data);
                    setRecords(response.data);
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({ 
                    mostrar: true, 
                    titulo: 'Error', 
                    texto: error.response?.data?.message || error.message, 
                    icono: 'error' 
                });
                setActivate(false);
            });
    };

    const cerrarToast = () => {
        setToast({
            ...toast,
            mostrar: false
        })
    }

    const gestionarBanco = (op, id) => (e) => {
        e.preventDefault();
        setOperacionModal(op);
        if (op !== 1) {
            setIdModal(id);
        } else {
            setIdModal('');
        }
        setShowModal(true);
    }

    const recargarTabla = () => {
        seleccionarRegistros();
    }

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
    };

    useEffect(() => {
        seleccionarRegistros();
    }, []);

    const cerrar = () => {
        props.setTabla(0)
    }

    return (
        <section className='col-8 m-0 p-0'>
            <header className='col-12 m-0 px-4 py-2 rounded-top d-flex align-items-center justify-content-between azulGradiant text-light'>
                <h3 className='m-0'>
                    Gestión de Bancos
                </h3>
                <a type='button' onClick={cerrar} className="text-light" style={{ cursor: 'pointer' }}>
                    Salir <i className="fas fa-times ms-2"></i>
                </a>
            </header>
            <form onSubmit={(e) => { e.preventDefault() }} className="d-flex justify-content-between p-2">
                <div className='col-4 m-0 p-0'>
                    <Input 
                        type="text"
                        ref={txtBuscador}
                        onChange={handleSearch}
                        placeholder="Buscar por código, nombre, sucursal, cuenta o gerente" 
                    />
                </div>
                <PrimaryButton 
                    icon='fa-plus m-0'
                    disabled={permiso?.toString().substring(1, 2) !== '1'}
                    onClick={gestionarBanco(1, '')}
                    title='Agregar Banco'
                >
                    Agregar Banco
                </PrimaryButton>
            </form>
            <div className="">
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {
                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                <tr key={index} style={{ padding: "0" }}>
                                    <td className='align-baseline' style={{ textAlign: "center" }}>{item.codban}</td>
                                    <td className='align-baseline' style={{ textAlign: "left" }}>{item.nomban}</td>
                                    <td className='align-baseline' style={{ textAlign: "left" }}>{item.sucursal}</td>
                                    <td className='align-baseline' style={{ textAlign: "center" }}>{item.nrocue}</td>
                                    <td className='align-baseline' style={{ textAlign: "left" }}>{item.gerente}</td>
                                    <td className='align-baseline' style={{ textAlign: "center" }}>
                                        <button 
                                            onClick={gestionarBanco(4, item.codban)} 
                                            className={permiso?.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                            title="Consultar"
                                            disabled={permiso?.toString().substring(0, 1) !== '1'}
                                        >
                                            <i className="fas fa-eye"></i>
                                        </button>
                                        {' '}
                                        <button 
                                            onClick={gestionarBanco(2, item.codban)} 
                                            className={permiso?.toString().substring(2, 3) === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                            title="Editar"
                                            disabled={permiso?.toString().substring(2, 3) !== '1'}
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                        {' '}
                                        <button 
                                            onClick={gestionarBanco(3, item.codban)} 
                                            className={permiso?.toString().substring(3, 4) === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                            title="Eliminar"
                                            disabled={permiso?.toString().substring(3, 4) !== '1'}
                                        >
                                            <i className="fa fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>

            {/* Modal de Bancos */}
            <Bancos
                show={showModal}
                setShow={setShowModal}
                operacion={operacionModal}
                id={idModal}
                onRecargar={recargarTabla}
               // setTabla={props.setTabla}
            />

            <Dimmer active={activate} inverted></Dimmer>
            <Mensaje 
                mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} 
            />
            <MensajeSiNo 
                mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} 
                onHideSi={handleCloseSi} 
            />
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast} 
            />
        </section>
    );
}

export default TablaBancos;